import 'moment/locale/th';
import React, { useState, useEffect } from 'react';
import { formatComma, tableWidth, getTheme, fetchJson } from 'helpers/helpers';
import callApi from 'helpers/callapi';
import moment from 'moment';
import _, { get, find, orderBy, uniqBy, filter } from 'lodash';
import { Link } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';

// Components
import CONSTANTS from 'constants/constants';
import { Button, Table, Pagination, Modal, Row, Col, Select, message, Input, Upload, Radio, Spin, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import { filterLabelAndValue } from 'helpers/helpers';

// constants
import ROUNDS from 'constants/rounds';
import TCAS_STATUSES from 'constants/tcas_statuses';
import DownloadModal from './DownloadModal';

// import AdminDetailModal from './AdminModal';

const ORDER_STATUS = CONSTANTS.orderStatus;
const ORDER_LABEL = CONSTANTS.orderLabels;
const BANK = CONSTANTS.banks;

const Option = Select.Option;

const TGATTPATSUBJECTS = ['TGAT', 'TPAT2', 'TPAT3', 'TPAT4', 'TPAT5'];

moment.locale('th');



export default () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const me = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const adminConfig = useSelector((state) => state.configs || {});

  const [sites, setSites] = useState([]);
  const [stats, setStats] = useState([]);
  const [provinceStats, setProvinceStats] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);

  const [tgattpatView, setTgattpatView] = useState('site');
  const [statError, setStatError] = useState(null); // 'not_found' | 'error'

  const getSchools = async () => {
    const _sites = await callApi({ url: '/exam-centers/me/sites' });
    setSites(_sites.data);
  };

  const getStat = async () => {
    // ไฟล์สถิติต่อศูนย์ถูกสร้างหลังวันสอบ (tasks/stats/exam/stat-center-examination-stat.js ฝั่ง API)
    // แล้วอัปโหลดขึ้น S3 — ก่อนหน้านั้น S3 ตอบ 404 จึงต้องแสดง empty state แทน error
    let tgattpatResult;
    try {
      setLoading(true);
      const stats = await callApi({ url: '/users/me/centers/stat' });
      tgattpatResult = await fetchJson(stats.tgattpat);
      setStatError(null);
    } catch (err) {
      console.error(err);
      setStatError(/404/.test(get(err, 'message', '')) ? 'not_found' : 'error');
      setStats([]);
      setProvinceStats([]);
      setLoading(false);
      return;
    }
    setLoading(false);

    let statBySiteCodes = _.groupBy(tgattpatResult, 'site_code');
    statBySiteCodes = _.map(statBySiteCodes, (statBySiteCodes) => {
      const masterData = _.maxBy(statBySiteCodes, 'unique_room_count')



      const statBySubjects = _.keyBy(statBySiteCodes, 'subject_name');

      const result = {
        site_code: masterData.site_code,
        site_name: masterData.site_name,
        center_code: masterData.center_code,
        room_count: masterData.unique_room_count, // find max value
        province: masterData.province,
      };

      TGATTPATSUBJECTS.forEach(subject => {
        const statBySubject = statBySubjects[`${subject}`]
        if (statBySubject) {
          result[`${subject}_total`] = statBySubject.total_count;
          result[`${subject}_absent`] = statBySubject.absent_count;
          result[`${subject}_present`] = statBySubject.present_count;
        }

      })
      return result

    })



    const results = _.sortBy(statBySiteCodes, ['site_code']);

    let provinceStats = _.reduce(results, (acc, result) => {
      const province = result.province;

      // Initialize province stats if not exists
      if (!acc[province]) {
        acc[province] = {
          province: province,
          room_count: 0,
        };

        // Initialize subject stats
        TGATTPATSUBJECTS.forEach(subject => {
          acc[province][`${subject}_total`] = 0;
          acc[province][`${subject}_present`] = 0;
          acc[province][`${subject}_absent`] = 0;
        });
      }

      // Add stats for this result
      acc[province].room_count += result.room_count;

      // Add subject stats
      TGATTPATSUBJECTS.forEach(subject => {
        acc[province][`${subject}_total`] += result[`${subject}_total`] || 0;
        acc[province][`${subject}_present`] += result[`${subject}_present`] || 0;
        acc[province][`${subject}_absent`] += result[`${subject}_absent`] || 0;
      });

      return acc;
    }, {});
    provinceStats = _.map(provinceStats, (provinceStats) => {
      return provinceStats
    });
    console.log(provinceStats);




    console.log(results);
    setStats(results);
    setProvinceStats(provinceStats);

  };


  useEffect(() => {
    getSchools().then(() => getStat());

  }, []);

  // {['1', '2', '4'].map((roundNumber) => {
  //   const round = find(ROUNDS, { value: `${roundNumber}_2565` });

  //   if (adminConfig.current_round !== roundNumber) {
  //     return <></>;
  //   }

  // }
  console.log(provinceStats);

  const tgattpatStatToRender = tgattpatView === 'site' ? stats : provinceStats;


  return (
    <div>
      <Spin spinning={loading} delay={0}>
        <div>
          <div className="t-main">
            <div className="flex justify-between">
              <h1>สถิติการสอบ </h1>



              <div className="action items-center">
                {/* <a href="" className="btn-ghost t-bg-while">
                  นำเข้าข้อมูล CSV
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.96663 1.6665C5.36413 1.6665 1.6333 5.39734 1.6333 9.99984C1.6333 14.6023 5.36413 18.3332 9.96663 18.3332C14.5691 18.3332 18.3 14.6023 18.3 9.99984C18.3 5.39734 14.5691 1.6665 9.96663 1.6665ZM8.12419 6.73079C8.22377 6.73079 8.32384 6.75447 8.41634 6.80322L13.4383 9.44727C13.6446 9.5556 13.7724 9.76773 13.772 10.0007C13.772 10.2336 13.6446 10.4449 13.4383 10.5532L8.41634 13.1965C8.32426 13.2448 8.22377 13.2689 8.12419 13.2689C8.01252 13.2689 7.9015 13.2385 7.80192 13.1785C7.61275 13.0644 7.5 12.8639 7.5 12.6431V7.35661C7.5 7.13577 7.61275 6.93529 7.80192 6.82113C7.9015 6.76071 8.01294 6.73079 8.12419 6.73079Z"
                      fill="currentColor"
                    />
                  </svg>
                </a> */}
                {/* <a
                  className="btn-ghost t-bg-while"
                  onClick={() => {
                    setModalVisible(true);
                  }}
                >
                  ดาวน์โหลด CSV
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.96663 1.6665C5.36413 1.6665 1.6333 5.39734 1.6333 9.99984C1.6333 14.6023 5.36413 18.3332 9.96663 18.3332C14.5691 18.3332 18.3 14.6023 18.3 9.99984C18.3 5.39734 14.5691 1.6665 9.96663 1.6665ZM8.12419 6.73079C8.22377 6.73079 8.32384 6.75447 8.41634 6.80322L13.4383 9.44727C13.6446 9.5556 13.7724 9.76773 13.772 10.0007C13.772 10.2336 13.6446 10.4449 13.4383 10.5532L8.41634 13.1965C8.32426 13.2448 8.22377 13.2689 8.12419 13.2689C8.01252 13.2689 7.9015 13.2385 7.80192 13.1785C7.61275 13.0644 7.5 12.8639 7.5 12.6431V7.35661C7.5 7.13577 7.61275 6.93529 7.80192 6.82113C7.9015 6.76071 8.01294 6.73079 8.12419 6.73079Z"
                      fill="currentColor"
                    />
                  </svg>
                </a> */}
              </div>

            </div>
            <div className="flex justify-between">
              <h2>
                <div>
                  <span>
                    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M18.75 8.50001H16.5V4.00001C16.5 3.75251 16.378 3.52101 16.1735 3.38101L11.4235 0.131006C11.168 -0.0439941 10.8315 -0.0439941 10.5765 0.131006L5.8265 3.38101C5.622 3.52101 5.5 3.75251 5.5 4.00001V8.50001H3.25C1.7335 8.50001 0.5 9.73401 0.5 11.25V20.25C0.5 20.664 0.8355 21 1.25 21H20.75C21.1645 21 21.5 20.664 21.5 20.25V11.25C21.5 9.73401 20.2665 8.50001 18.75 8.50001ZM5.25 17.5C5.25 17.776 5.026 18 4.75 18H4.25C3.974 18 3.75 17.776 3.75 17.5V15C3.75 14.724 3.974 14.5 4.25 14.5H4.75C5.026 14.5 5.25 14.724 5.25 15V17.5ZM5.25 12.5C5.25 12.776 5.026 13 4.75 13H4.25C3.974 13 3.75 12.776 3.75 12.5V12C3.75 11.724 3.974 11.5 4.25 11.5H4.75C5.026 11.5 5.25 11.724 5.25 12V12.5ZM8.5 17.5C8.5 17.776 8.276 18 8 18H7.5C7.224 18 7 17.776 7 17.5V15C7 14.724 7.224 14.5 7.5 14.5H8C8.276 14.5 8.5 14.724 8.5 15V17.5ZM8.5 12.5C8.5 12.776 8.276 13 8 13H7.5C7.224 13 7 12.776 7 12.5V12C7 11.724 7.224 11.5 7.5 11.5H8C8.276 11.5 8.5 11.724 8.5 12V12.5ZM11.75 17.5C11.75 17.776 11.526 18 11.25 18H10.75C10.474 18 10.25 17.776 10.25 17.5V15C10.25 14.724 10.474 14.5 10.75 14.5H11.25C11.526 14.5 11.75 14.724 11.75 15V17.5ZM11.75 12.5C11.75 12.776 11.526 13 11.25 13H10.75C10.474 13 10.25 12.776 10.25 12.5V12C10.25 11.724 10.474 11.5 10.75 11.5H11.25C11.526 11.5 11.75 11.724 11.75 12V12.5ZM11 9.00001C9.8955 9.00001 9 8.10451 9 7.00001C9 5.89551 9.8955 5.00001 11 5.00001C12.1045 5.00001 13 5.89551 13 7.00001C13 8.10451 12.1045 9.00001 11 9.00001ZM15 17.5C15 17.776 14.776 18 14.5 18H14C13.724 18 13.5 17.776 13.5 17.5V15C13.5 14.724 13.724 14.5 14 14.5H14.5C14.776 14.5 15 14.724 15 15V17.5ZM15 12.5C15 12.776 14.776 13 14.5 13H14C13.724 13 13.5 12.776 13.5 12.5V12C13.5 11.724 13.724 11.5 14 11.5H14.5C14.776 11.5 15 11.724 15 12V12.5ZM18.25 17.5C18.25 17.776 18.026 18 17.75 18H17.25C16.974 18 16.75 17.776 16.75 17.5V15C16.75 14.724 16.974 14.5 17.25 14.5H17.75C18.026 14.5 18.25 14.724 18.25 15V17.5ZM18.25 12.5C18.25 12.776 18.026 13 17.75 13H17.25C16.974 13 16.75 12.776 16.75 12.5V12C16.75 11.724 16.974 11.5 17.25 11.5H17.75C18.026 11.5 18.25 11.724 18.25 12V12.5Z"
                        fill="#FF8A00"
                      />
                    </svg>
                  </span>{' '}
                  TGAT / TPAT
                </div>
              </h2>
              <div className="action items-center"><div className="float-right">
                <Radio.Group defaultValue="site" onChange={(e) => setTgattpatView(e.target.value)} value={tgattpatView} buttonStyle="solid" className="mb-4">
                  <Radio.Button value="site">สนามสอบ</Radio.Button>
                  <Radio.Button value="province">จังหวัด</Radio.Button>
                </Radio.Group>
              </div>
              </div>
            </div>

            {statError && (
              <div className="t-form" style={{ display: 'block' }}>
                {statError === 'not_found'
                  ? 'ยังไม่มีข้อมูลสถิติการสอบของศูนย์สอบนี้ ข้อมูลจะแสดงหลังจากการสอบและประมวลผลการเข้าสอบเสร็จสิ้น'
                  : 'ไม่สามารถโหลดข้อมูลสถิติได้ กรุณาลองใหม่อีกครั้ง'}
              </div>
            )}
            {!statError && (
            <table className="t-table t-table-striped">
              <thead className="th-orange">
                <tr>
                  <th rowSpan="2">ชื่อสนามสอบ</th>
                  <th rowSpan="2">จน.ห้อง</th>
                  {TGATTPATSUBJECTS.map((subject) => (
                    <th colSpan="3" className="text-center">{subject}</th>
                  ))}
                </tr>
                <tr>
                  {TGATTPATSUBJECTS.map(() => (
                    <>
                      <th className="text-right">ผู้สมัคร</th>
                      <th className="text-right">เข้าสอบ</th>
                      <th className="text-right">ขาดสอบ</th>
                    </>
                  ))}
                </tr>
              </thead>
              <tbody>


                {tgattpatStatToRender.map((stat, index) => {

                  return (
                    <tr>
                      {/* <td>{index + 1}</td> */}
                      <td>{tgattpatView === 'site' ? stat.site_name : stat.province}</td>
                      <td>{stat.room_count}</td>
                      {TGATTPATSUBJECTS.map((subject) => (
                        <>
                          <td className="text-right">{stat[`${subject}_total`] ? stat[`${subject}_total`].toLocaleString() : '-'}</td>
                          <td className="text-right">{stat[`${subject}_present`] ? stat[`${subject}_present`].toLocaleString() : '-'}</td>
                          <td className="text-right">{stat[`${subject}_absent`] ? stat[`${subject}_absent`].toLocaleString() : '-'}</td>
                        </>
                      ))}


                    </tr>
                  );
                })}
              </tbody>
            </table>
            )}
            <br />
          </div>
        </div>
      </Spin>
      <DownloadModal
        setIsVisible={setModalVisible}
        isVisible={modalVisible}
        centerCode={me.center_code}
      ></DownloadModal>
    </div>
  );
};

const ContentBody = styled.div`
  background-color: white;
  border: 1px solid ${getTheme`colors.gray`};
  padding: 20px;
`;
